<template>
  <div>
    <v-layout wrap justify-center mt-12>
      <v-flex xs12 sm8>
        <h1>{{ $t('a') }}</h1>
        <v-layout wrap mt-2 mb-2 justify-center>
          <v-flex xs12 text-center>
            <img :src="images.top" height="250px" class="mb-4"/>
          </v-flex>
          <v-flex xs8 text-center>
            <v-card class="px-12 py-6">
              <div v-if="!success">
                <span>{{ $t('c') }}</span>
                <v-form ref="form" @submit.prevent="sendEmail" v-model="isFormValid">
                  <v-layout wrap justify-center>
                    <v-flex xs10 class="mt-6 text-center">
                      <div>
                        <v-text-field v-model="emailAddress" outlined type="email" :label="$t('d')" :rules="[emailRules]" :disabled="isPending"/>
                        <v-progress-linear v-if="isPending" indeterminate color="primary"></v-progress-linear>
                        <v-btn v-else type="submit" class="secondary" :disabled="isPending || !isFormValid">{{ $t('e') }}</v-btn>
                        <div v-if="errorMessage" class="red--text mt-5">{{ errorMessage }}</div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-form>
              </div>
              <div v-else>
                <div><v-icon color="secondary">check</v-icon></div>
                <div>{{ $t('f') }} {{ emailAddress }}</div>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

import axios from 'axios'
import vuei18n from '@/i18n'

const functionsUrlBase = {
  'localhost': 'http://localhost:5001/esnwebservices-dev/us-central1',
  'esnwebservices-dev.firebaseapp.com': 'https://europe-west1-esnwebservices-dev.cloudfunctions.net',
  'esnwebservices-prod.firebaseapp.com': 'https://europe-west1-esnwebservices-prod.cloudfunctions.net',
  'esnwebservices.com': 'https://europe-west1-esnwebservices-prod.cloudfunctions.net'
}[window.location.hostname]

export default {
  data: () => ({
    emailAddress: null,
    isFormValid: false,
    isPending: false,
    success: false,
    errorMessage: null,
    images: {
      top: require('@/assets/app/images/password_flatline.svg'),
    },
  }),
  methods: {
    emailRules(v) {
      if (!v) return this.$t('g')
      if (!/.+@.+\..+/.test(v)) return this.$t('h')
      return true
    },
    async sendEmail() {
      const _this = this
      this.errorMessage = null
      this.isPending = true
      const { isUserExisting, isConsultant } = (await this.$functions.httpsCallable('isUserExisting')({ email: this.emailAddress })).data
      if (isUserExisting && isConsultant) return this.$router.push('/consultant');

      await axios.post(`${functionsUrlBase}/sendEmailForPasswordReset`, {
        email: this.emailAddress,
        locale: vuei18n.locale === 'en' ? 'en' : 'fr'
      }).then(function() {
        // Email sent.
        _this.success = true
        _this.isPending = false
      }).catch(function(error) {
        console.error(error); // eslint-disable-line
        // An error happened.
        _this.isPending = false
        _this.errorMessage = _this.$t('i')
      });
    }
  }
}
</script>


<i18n>
{
  "fr": {
    "a": "Réinitialisation du mot de passe",
    "b": "Entrez l'adresse email de votre compte.",
    "c": "Nous allons vous envoyer un email contenant un lien pour réinitialiser votre mot de passe.",
    "d": "Votre adresse email",
    "e": "Recevoir l'email de réinitialisation",
    "f": "Un lien de réinitialisation de votre mot de passe vous a été envoyé à",
    "g": "Votre adresse email est requise.",
    "h": "Votre adresse email doit être au bon format.",
    "i": "Erreur lors de l'envoi de l'email."
  },
  "en": {
    "a": "Reset your password",
    "b": "Enter your user account's email.",
    "c": "We will send you a password reset link.",
    "d": "Your email address",
    "e": "Send password reset email",
    "f": "Check your email for a link to reset your password. We sent it to",
    "g": "Your email address is required.",
    "h": "Your email address must be in an appropriate format.",
    "i": "Error while sending the email."
  }
}
</i18n>